import { render } from "./component.vue?vue&type=template&id=da540cee"
import script from "./component.vue?vue&type=script&setup=true&lang=js"
export * from "./component.vue?vue&type=script&setup=true&lang=js"

import "./component.vue?vue&type=style&index=0&id=da540cee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/plugins/site-drawer/component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da540cee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da540cee', __exports__)) {
    api.reload('da540cee', __exports__)
  }
  
  module.hot.accept("./component.vue?vue&type=template&id=da540cee", () => {
    api.rerender('da540cee', render)
  })

}


export default __exports__